export class UserLocation {
  public LocationId : number;
  public MID : string;
  public Public_API_Key : string;
  public Secret_API_Key : string; 
}